<!-- Divider -->
<div class="calsoft-horizontal-navigation-item-wrapper divider"></div>
